import { useRecentThreadMetadata } from '#pplx/frontend/apps/ask/hooks/threads-hooks/useRecentThreadUpdates.js';
import { useThreadMetadata } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { useMemo } from 'react';
function normalizeVisibility(value) {
    return value === 'VISIBLE' || value === 'MASKED' ? value : null;
}
/**
 * Merges real-time SSE thread metadata with the REST response loaded on
 * page init. SSE values take priority (they reflect the latest streaming
 * state); REST values act as a fallback so data survives page reloads.
 *
 * Returns null when contextUuid is undefined (no thread in view).
 */
export function useMergedThreadMetadata(contextUuid) {
    const rest = useThreadMetadata();
    const sse = useRecentThreadMetadata(contextUuid);
    return useMemo(() => {
        if (!contextUuid)
            return null;
        return {
            title: sse?.title ?? rest?.title ?? null,
            taskDescription: sse?.taskDescription ?? rest?.thread_status_summary ?? null,
            answerPreview: sse?.answerPreview ?? null,
            status: sse?.status ?? rest?.thread_status ?? null,
            unread: sse?.unread ?? null,
            updatedAt: sse?.updatedAt ?? rest?.updated_at ?? null,
            lockedReason: sse?.lockedReason ?? rest?.locked_reason ?? null,
            wakeAt: sse?.wakeAt ?? rest?.wake_at ?? null,
            crons: sse?.crons ?? rest?.crons ?? null,
            workflowSnapshots: sse?.workflowSnapshots ?? rest?.workflow_snapshots ?? null,
            threadAccess: sse?.threadAccess ?? null,
            sensitiveClaimsVisibility: sse?.sensitiveClaimsVisibility ?? normalizeVisibility(rest?.sensitive_claims_visibility),
        };
    }, [contextUuid, sse, rest]);
}
//# sourceMappingURL=useMergedThreadMetadata.js.map